<template>
    <div id="checkoutComponent">
        <div class="checkoutComponent-inner">
            <div class="wz-row">
                <div class="left-sidebar sidebar">
                    <div class="sidebar-inner confirmation-arear">
                        <div class="header-info">
                            <h2>1. Confirm order information</h2>
                        </div>
                        <div class="info-area">
                            <form action="" role="form">
                                <div class="maps">
                                    <GmapMap
                                            ref="maps"
                                            :center="{lat: $mapCenter.Pos_Latitude, lng: $mapCenter.Pos_Longitude}"
                                            :zoom="13"
                                            style="width: 100%; height: 100%;"
                                    >
                                      <gmap-polygon
                                        v-if="paths.length > 0"
                                        :paths="paths"
                                        ref="polygon"
                                        :options="{
                                                    geodesic: true,
                                                    strokeColor: '#FFd000',
                                                    strokeOpacity: 1.0,
                                                    strokeWeight: 3,
                                                    fillColor: '#FFd000',
                                                    fillOpacity: 0.35
                                                }"
                                      >
                                      </gmap-polygon>
                                    <GmapMarker v-if="cart.longitude && cart.latitude"
                                                :position="{lat:cart.latitude, lng:cart.longitude}"
                                        />
                                    </GmapMap>
                                </div>
                                <div class="form">
                                    <div class="form-group">
                                        <i class="fa fa-map-marker" aria-hidden="true"></i>
                                        <gmap-autocomplete
                                                ref="mapRef"
                                                @place_changed="setPlace"
                                                placeholder="Enter shipping address"
                                                :value="cart.to_address"
                                                :options="{
                                                    componentRestrictions:{
                                                        country:['vn']
                                                    },
                                                    strictBounds:true
                                                }"
                                        >
                                        </gmap-autocomplete>
                                    </div>
                                    <div class="form-group">
                                        <textarea required="" cols="30" rows="6"
                                                  placeholder="Your apartment or house number?, or any other information to help us with your order..."
                                                  v-model="cart.note"></textarea>
                                    </div>
                                    <div class="form-group half">
                                        <i class="fa fa-phone" aria-hidden="true"></i>
                                        <input type="text" required="" placeholder="Phone number" v-model="cart.user_id"
                                               v-mask="'84##########'" disabled>
                                    </div>
                                    <div class="form-group half">
                                        <i class="fa fa-user" aria-hidden="true"></i>
                                        <input type="text" required="" placeholder="Receiver" v-model="cart.username">
                                    </div>
                                    <div class="clearfix"></div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="right-sidebar sidebar">
                    <div class="sidebar-inner">
                        <div class="cartItems" v-if="cart.ordersItem.length">
                            <div class="item" v-for="(item,index) in cart.ordersItem">
                                <div class="name" v-on:click="openModalProduct(item.product,index,item.order,item.order.options)">
                                    <div class="itemQuantity"><span>{{item.order.Quantity}}x</span></div>
                                  <div class="itemInfo">
                                    <p class="itemName">{{ item.order.Item_Name }}</p>
                                    <p>Price: {{ item.order.Price }}đ</p>
                                    <div class="options">
                                      <div class="opItem" v-for="(op,key) in item.order.options">

                                        <template v-if="typeof op.options === 'string'">
                                          {{ op.name }} : {{ op.options }}
                                        </template>
                                        <template v-else>

                                          <template v-if="op.max === 1 && op.min === 1">
                                            <template v-for="val in op.options">
                                              <p v-if="val && val.quantity">{{ op.name }} : <span class="opVal">{{ val.name }} </span>
                                              </p>
                                            </template>
                                          </template>

                                          <template v-else>
                                            <p>{{ op.name }} : </p>
                                            <template v-for="val in op.options">
                                              <p v-if="val && val.quantity"> + <span class="opVal">{{ val.name }}: {{ val.quantity }}
                                                      <template
                                                        v-if="val.ta_price">x {{ val.ta_price }}đ</template></span></p>
                                            </template>
                                          </template>

                                        </template>
                                      </div>
                                    </div>
                                    <p class="note" v-if="item.order.Note">Note: <em>{{item.order.Note}}</em></p>
                                  </div>
                                </div>
                                <div class="price">
                                    {{((item.order.Price + item.order.plusPrice) * item.order.Quantity ) | formatPrice}}
                                </div>
                                <span class="deleteItem" v-on:click="deleteCartItem(index)"><img
                                        src="../assets/images/delete.png" alt=""></span>
                            </div>
                        </div>
                        <div class="order-body">
                            <div class="table total-items">
                                <div class="cell">Total (<span class="count">{{cart | countTotalItems}}</span> items)
                                </div>
                                <div class="cell text-right">{{cart | totalPrice}}</div>
                            </div>
                            <div class="table sale" v-if="cart.Discount_Amount">
                                <div class="cell">Discount</div>
                                <div class="cell text-right">-{{cart.Discount_Amount | formatPrice}}</div>
                                <span class="cell text-right remove" v-on:click="clearCoupon"><img src="../assets/images/remove.png"
                                                                          alt="Remove"></span>
                            </div>

                            <div class="coupon">
                                <form action="" method="POST" role="form">
                                    <input type="text" placeholder="Enter coupon code" v-model="cart.coupon_log_id">
                                    <button class="" type="button" v-on:click="checkCoupon">Apply</button>
                                    <p v-if="couponChecking" class="process">Verifying... please wait   <i class="fa fa-spinner fa-spin"></i></p>
                                </form>
                            </div>

                          <div v-show="cart.to_address && cart.to_address.length >=6">
                            <div class="table shipment" v-if="cart.ship_price_real !== -1" style="margin-top: 5px">
                              <div class="cell"><b>Delivery Fee</b></div>
                              <div class="cell text-right">
                                <span v-if="Number.isInteger(cart.ship_price_real) && cart.ship_price_real > 0">{{cart.ship_price_real | formatPrice}}</span>
                              </div>
                            </div>
                          </div>

                        </div>
                        <div class="order-footer">
                            <div class="table">
                                <div class="cell total-label">Total</div>
                                <div class="cell text-right"><strong>{{cart | totalPriceCart}}</strong></div>
                            </div>
                            <div class="table">
                              <div class="cell total-label">Total (VAT 8%)</div>
                              <div class="cell text-right"><strong>{{cart | totalPriceWidthVAT(true) }}</strong></div>
                            </div>
                            <button class="btn-back" type="button" v-on:click="gotoShop">Add more items</button>
                            <button class="btn-order" type="button" @click="checkCart" :disabled="allowOrder!==true">Confirm Order</button>
                        </div>
                    </div>
                </div>
                <!-- modal-->
                <modal v-if="showModal" @close="showModal = true" class="modal-confirm">
                    <h2 slot="header">Confirm order information</h2>
                    <template slot="body">
                        <p><i class="fa fa-map-marker"></i>{{cart.to_address}}</p>
                        <p><i class="fa fa-user"></i>{{cart.username}}</p>
                        <p><i class="fa fa-mobile"></i>{{cart.user_id}}</p>
                    </template>
                    <template slot="footer">
                        <p>Total: <strong>{{cart | totalPriceCart}}</strong></p>
                        <p>Total (VAT 8%): <strong>{{cart | totalPriceWidthVAT(true)}}</strong></p>
                        <div class="action" v-bind:class="{ loading: loading }">
                            <button type="button" class="btn btn-remove" v-on:click="showModal = false">Cancel</button>
                            <button type="button" class="btn btn-order" v-on:click="ordering" :disabled="allowOrder!==true">Order</button>
                        </div>
                    </template>
                </modal>
                <!-- modal-->
            </div>
        </div>
        <modal-product v-if="modalProduct.active"
                       :order="modalProduct.orderItem"
                       :test="modalProduct.test"
                       :product="modalProduct.product"
                       @close="modalProduct.active = false" :activeId="modalProduct.activeId" @updateCart="updateCart">
            <span v-on:click="modalProduct.active = false" class="closeModal"><img src="../assets/images/close.png"
                                                                                   alt="Close"></span>
        </modal-product>
    </div>
</template>

<script>
    import Modal from './Modal.vue'
    import coordinates from '../map'
    export default {
        name: 'Checkout',
        components: {
            Modal
        },
        data() {
            return {
                mode: wzFoodbookData.mode || 'dev',
                domain: 'thaistreet.com.vn',
                showModal: false,
                couponChecking:false,
                cart: this.$cart,
                modalProduct: {
                    active: false,
                    activeId: 0,
                    product: null,
                    orderItem: null
                },
                polygon:null,
                loading: false,
                paths: coordinates,
                allowOrder: true,
                allowLastAddress: false,
            };
        },
        mounted() {
            if (this.$refs.maps) {
                /*this.$refs.maps.$mapPromise.then(() => {
                    var geolocation = {
                        lat: 10.780833,
                        lng: 106.756944
                    };
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: 3000
                    });
                    this.$refs.mapRef.$autocomplete.setBounds(circle.getBounds());
                    //console.log(this.$refs.polygon);
                })*/
            }
        },
        created() {
            if (!this.cart.ordersItem.length || !this.$foodbookConfig.user_phone) {
                window.location.replace(this.$foodbookConfig.menupage);
            }

            this.cart.user_id = this.$foodbookConfig.user_phone;

            if (this.$cart.latitude && this.$cart.longitude) {
                this.cacularShipFee();
            }
        },
        filters: {},
        methods: {
            //Lay dia chi va lat lng
            setPlace(place) {
              if (place.geometry) {
                this.$gmapApiPromiseLazy().then(() => {
                  if (google.maps.geometry.poly.containsLocation(place.geometry.location, this.$refs.polygon.$polygonObject)) {
                    this.cart.to_address = place.formatted_address;
                    this.cart.longitude = place.geometry.location.lng();
                    this.cart.latitude = place.geometry.location.lat();
                    this.cacularShipFee();
                  } else {
                    this.cart.to_address = '';
                    this.$refs.mapRef.$el.value = '';
                    this.cart.longitude = null;
                    this.cart.latitude = null;

                    /*
                    Thai Street website" "You live outside our own delivery area, however we may be able to arrange delivery for you via a third party. Please instead call us on 02866549525 to place your order and confirm delivery - Thanks!"
                    Snap website "You live outside our own delivery area, however we may be able to arrange delivery for you via a third party. Please instead call us on 02835194532 to place your order and confirm delivery - Thanks!"
                     */


                    this.$toasted.show("You live outside our own delivery area, however we may be able to arrange delivery for you via a third party. Please instead call us on 02835194532 to place your order and confirm delivery - Thanks!", {
                      position: "top-center",
                      duration: 5000,
                      type: 'error'
                    });
                    return;
                  }
                });
              }
            },
            //Edit Order Item
            openModalProduct(p, index, orderItem, options=null) {
                this.modalProduct.product = p;
                this.modalProduct.activeId = index;
                this.modalProduct.orderItem = orderItem;
                this.modalProduct.active = true;
            },
            //Delete Cart item
            deleteCartItem(index) {
                this.cart.ordersItem.splice(index, 1);
                this.updateSessionCart();
                if (!this.cart.ordersItem.length) {
                    window.location.replace(this.$foodbookConfig.menupage);
                }
            },
            //Update cart Item
            updateCart(order, product, index) {
                if (index > -1) {
                    //Chinh sua gio hang
                    this.$set(this.cart.ordersItem, index, {'order': order, 'product': product});
                } else {
                    //Them moi
                    this.cart.ordersItem.push({'order': order, 'product': product})
                }
                //Update session cart
                this.updateSessionCart();
                this.modalProduct.active = false;

            },
            //Update session cart
            updateSessionCart() {
                sessionStorage.cart = JSON.stringify(this.cart);
            },
            //Tính shipment
            //Nó chỗ này nè anh
            cacularShipFee() {

              //Thai Street- có giới hạn bản đồ giao hàng trên website- phí ship đổ về luôn bằng 20.000 trong vùng giới hạn giao- có giới hạn bản đồ giao hàng trên website

              const domains = [
                'hemthai.com.vn',
                'hemthai.lc',
                'thaistreet.com.vn',
                'thaistreet.lc'
              ]
              if ( this.cart && domains.includes(this.domain) ) {
                this.cart.ship_price_real = 20000; //20k delivery
              }

              this.allowOrder = true
              return 20000;

            },
            //Check coupon code
            checkCoupon() {
                //Kiem tra ma coupon
                if (!this.cart.coupon_log_id.trim()) {
                    this.$toasted.show("Discount codes cannot be blank", {
                        position: "top-center",
                        duration: 50000,
                        type: 'error',
                    });
                    return;
                }

                //Kiem tra san pham trong gio hang
                if (!this.cart.ordersItem.length) {
                    this.$toasted.show("Please select the product you want to buy!", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }

                //Check so dien thoai
                if (this.cart.user_id.length < 11) {
                    this.$toasted.show("Phone numbers must be more than 10 numbers", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (this.cart.user_id.substring(0, 2) !== '84') {
                    this.$toasted.show("Phone number is incorrect (84xxxxxxx)", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }

                //Render ra san pham

                let order_data_item = this.$options.filters.renderOrderItems(this.cart);
                this.couponChecking = true; // bật spinner
                this.$http.get(this.$foodbookConfig.wpapi + '/coupon', {
                    params: {
                        pos_id: this.$foodbookConfig.pos_id,
                        pos_parent: this.$foodbookConfig.pos_name,
                        voucher_code: this.cart.coupon_log_id,
                        membership_id: this.cart.user_id,
                        order_data_item: order_data_item
                    }
                }).then(response => {
                    this.couponChecking = false; // tắt spinner
                    if (response.body.error) {
                        //console.log(response.body.error.message);
                        this.$toasted.show("Sorry, this appears to be an invalid code. Please contact us", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        this.cart.Discount_Amount = null;
                    } else {
                        if (response.body.data && response.body.data.Code == 4) {
                            this.cart.Discount_Amount = response.body.data.Discount_Amount;
                            sessionStorage.cart = JSON.stringify(this.cart);
                        }else{
                            this.$toasted.show("Sorry, this appears to be an invalid code. Please contact us", {
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                            this.cart.Discount_Amount = null;
                        }
                    }
                }, response => {
                    this.couponChecking = false; // tắt spinner
                    this.$toasted.show('Could not check discount code', {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    this.cart.Discount_Amount = null;
                });
            },
            //Xoa Coupon
            clearCoupon() {
                this.cart.Discount_Amount = 0;
                this.cart.coupon_log_id = '';
                sessionStorage.cart = JSON.stringify(this.cart);
            },
            //Kiem tra thong tin
            checkCart() {
                console.log(this.cart);
                //Kiem tra thong tin truoc khi dat hang
                if (!this.cart.to_address) {
                    this.$toasted.show("Your address is invalid !", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }

                if (!this.cart.latitude || !this.cart.longitude) {
                    this.$toasted.show("The delivery location cannot be determined", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }

                this.cacularShipFee();

                if (!this.cart.user_id || this.cart.user_id.length < 11 || this.cart.user_id.length > 12) {
                    this.$toasted.show("Incorrect telephone number", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }
                if (!this.cart.username) {
                    this.$toasted.show("Please enter your name", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }

                if (!this.cart.ordersItem.length) {
                    this.$toasted.show("There are no products in the shopping cart", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                    return;
                }

                this.showModal = true;
                sessionStorage.cart = JSON.stringify(this.cart);
            },

            //Dat hang
            ordering() {
                let amount = 0;
                if (this.cart.ordersItem.length) {
                    amount = this.$options.filters.totalPriceNotFormat(this.cart);
                }

                let order_data_item = this.$options.filters.renderOrderItems(this.cart);
                let order = {
                    pos_id: this.$foodbookConfig.pos_id,
                    pos_parent: this.$foodbookConfig.pos_name,
                    adapt_to_online: 0,
                    coupon_log_id: this.cart.coupon_log_id,
                    user_id: this.cart.user_id,
                    username: this.cart.username,
                    note: this.cart.note,
                    longitude: this.cart.longitude,
                    latitude: this.cart.latitude,
                    to_address: this.cart.to_address,
                    ship_price_real: this.cart.ship_price_real,
                    vat_tax_rate: 0.08, // VAT = 8%
                    vat_tax_amount: amount * 0.08,
                    amount: amount,
                    total_amount: amount,
                    order_data_item: order_data_item,
                    PaymentInfo: {
                        Payment_Method: "PAYMENT_ON_DELIVERY",
                        Payment_Info: "1",
                        Amount: 0
                    },
                };

                if (this.cart.booking_info) {
                    _.assign(order, {'booking_info': this.cart.booking_info});
                }
                this.loading = true;
                // console.log('order',order)
                // return;
                this.$http.post(this.$foodbookConfig.wpapi + '/orders', order).then(response => {
                    if (response.body.error) {
                        if(response.body.error.code == 1502){
                            this.$toasted.show('Sorry, we are closed for delivery orders at this time. Please refer to our delivery FAQ for more information.', {
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }else{
                            this.$toasted.show('Sorry, the order failed. Please refer to our delivery FAQ for more information', {
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                        }
                        this.loading = false;
                        console.log(response.body.error.message);
                    } else {
                        this.cart.ordersItem = [];
                        sessionStorage.removeItem('cart');
                        sessionStorage.setItem('order' + response.body.data, JSON.stringify(order));
                        this.loading = false;
                        window.location.replace(this.$foodbookConfig.orderpage + "?orderid=" + response.body.data);
                    }
                }, response => {

                });
            },
            gotoShop(){
                window.location.replace(this.$foodbookConfig.menupage);
            }
        }
    }
</script>
<style>

button[disabled="disabled"] {
  cursor: default;
  pointer-events: none;
  opacity: 0.68;
  background-color: #999!important;
  border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue